// client/src/components/comunicacao/agendadas/ComunicacaoAgendadaRow.js
import React from 'react';
import { MoreVertical, Mail, MessageCircle, Smartphone, Calendar } from 'lucide-react';
import PropTypes from 'prop-types';

const STATUS_LABELS = {
    Pendente: { label: 'Pendente', className: 'badge-yellow' },
    Processando: { label: 'Processando', className: 'badge-blue' },
    Enviado: { label: 'Enviado', className: 'badge-green' },
    Falha: { label: 'Falha', className: 'badge-red' },
    Cancelado: { label: 'Cancelado', className: 'badge-gray' }
};

const ComunicacaoAgendadaRow = ({ item, onOpenActions }) => {
    const getCanalIcon = (canal) => {
        switch (canal) {
            case 'WhatsApp': return <MessageCircle size={16} className="text-green-600" />;
            case 'Email': return <Mail size={16} className="text-blue-600" />;
            case 'SMS': return <Smartphone size={16} className="text-purple-600" />;
            default: return <MessageCircle size={16} />;
        }
    };

    const statusInfo = STATUS_LABELS[item.status] || { label: item.status, className: 'badge-gray' };
    const dataEnvio = item.dataEnvioCalculada ? new Date(item.dataEnvioCalculada) : null;

    return (
        <tr className="hover:bg-gray-50">
            <td className="py-3">
                <div className="flex items-center">
                    {getCanalIcon(item.template?.canal)}
                    <span className="ml-2 text-sm text-gray-900">{item.template?.nome || 'Template removido'}</span>
                </div>
            </td>

            <td className="py-3">
                <span className="text-sm text-gray-900">{item.participanteInfo?.nome || 'Cliente'}</span>
            </td>

            <td className="py-3">
                <span className="text-sm text-gray-900">{item.evento || '—'}</span>
            </td>

            <td className="py-3">
                <div className="flex items-center">
                    <Calendar size={16} className="text-gray-600 mr-2" />
                    <div>
                        <span className="text-sm text-gray-900">{dataEnvio ? dataEnvio.toLocaleDateString('pt-BR') : '—'}</span>
                        {dataEnvio && <><br /><span className="text-xs text-gray-500">{dataEnvio.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</span></>}
                    </div>
                </div>
            </td>

            <td className="py-3">
                <span className={`badge ${statusInfo.className}`}>{statusInfo.label}</span>
            </td>

            <td className="text-right">
                <button
                    onClick={() => onOpenActions(item)}
                    title="Ações"
                    className="action-button-icon text-gray-600 hover:text-gray-900"
                >
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
};

ComunicacaoAgendadaRow.propTypes = {
    item: PropTypes.shape({
        _id: PropTypes.string,
        status: PropTypes.string,
        evento: PropTypes.string,
        dataEnvioCalculada: PropTypes.string,
        template: PropTypes.shape({
            nome: PropTypes.string,
            canal: PropTypes.string,
        }),
        participanteInfo: PropTypes.shape({
            nome: PropTypes.string,
        }),
    }).isRequired,
    onOpenActions: PropTypes.func.isRequired,
};

export default ComunicacaoAgendadaRow;
